export class IxGenericTreeTestIds {
  public static readonly SEARCH_BOX = 'search-box';

  public static CHECK_BOX_ID = (id: string) => `checkbox-${id}`;

  public static NODE_ID = (id: string) => `node-${id}`;

  public static NODE_LABEL = (id: string) => `label-${id}`;

  public static NODE_COUNT = (id: string) => `count-${id}`;

  public static NODE_EXPAND_TOGGLE = (id: string) => `tree-node-toggle-${id}`;
}
